<template>
  <div class="header">
    <div class="title">
      <div class="logo">
        <img src="../../assets/img/logos.png" alt />
        <img src="../../assets/img/logo.png" alt style="height:24px;" />
      </div>
      <h3>龙烟三维可视化管控平台</h3>
    </div>
    <div class="content">
      <div class="left">
        当前位置：
        <span>{{position}}</span>
      </div>
      <ul class="center">
        <router-link to="/number" tag="li" :class="{on:active=='number'}">数字库区</router-link>
        <router-link to="/home" tag="li" :class="{on:active=='home'}">设备维保</router-link>
        <router-link to="/order" tag="li" :class="{on:active=='order'}">订单管理</router-link>
        <router-link to="/stock" tag="li" :class="{on:active=='stock'}">库存管理</router-link>
      </ul>
      <ul class="right">
        <li @click="ReLoad()">
          <i></i>
          <span>刷新</span>
        </li>
        <li>
          <i></i>
          <span>消息</span>
        </li>
        <li>
          <i></i>
          <span>设置</span>
        </li>
        <li @click="LoadLogin()">
          <i></i>
          <span>注销</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      position: "设备维保",
      active: "home"
    };
  },
  mounted() {
    this.active = this.$route.path.slice(1);
    if (this.active == "home") {
      this.position = "设备维保";
    } else if (this.active == "number") {
      this.position = "数字库区";
    } else if (this.active == "order") {
      this.position = "订单管理";
    } else if (this.active == "stock") {
      this.position = "库存管理";
    }
  },
  methods: {
    HandleClick(index, position, url) {
      this.istrue = index;
      this.position = position;
      this.$router.push({ path: url });
    },
    ReLoad() {
      location.reload(false);
    },
    LoadLogin() {
      if (confirm("是否确认注销登录？")) {
        this.$router.push({ path: "/" });

      } else {
      }
      
    }
  }
};
</script>

<style scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 1920px;
  max-width: 1920px;
  color: #248f68;
  box-sizing: border-box;
  background: #fff;
  z-index: 3;
}
.title {
  height: 63px;
  line-height: 63px;
  font-size: 14px;
  background: url("../../assets/img/header-title.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.title h3 {
  color: #fff;
  text-align: center;
  font-weight: bold;
  font-size: 28px;
}
.logo {
  position: absolute;
  top: 0;
  left: 15px;
  width: 400px;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}
.logo > img {
  margin-left: 20px;
}
.content {
  padding-bottom: 7px;
  height: 44px;
  line-height: 44px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.center {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.center li {
  padding: 0 22px;
  cursor: pointer;
  border-radius: 8px;
}

.center .on {
  background-color: #298f68;
  color: #fff;
}
.router-link-active {
  background-color: #298f68;
  color: #fff;
}
.right {
  padding-right: 50px;
  display: flex;
  flex-direction: row;
  justify-content: end;
}
.right li {
  padding: 0 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.right li i {
  display: block;
  width: 22px;
  height: 22px;
}
.right li:first-child i {
  background: url("../../assets/img/header-sx.png") no-repeat;
  background-size: contain;
}
.right li:nth-child(2) i {
  background: url("../../assets/img/header-xx.png") no-repeat;
  background-size: contain;
}
.right li:nth-child(3) i {
  background: url("../../assets/img/header-sz.png") no-repeat;
  background-size: contain;
}
.right li:nth-child(4) i {
  background: url("../../assets/img/header-tc.png") no-repeat;
  background-size: contain;
}
.right li span {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #c5aa61;
}
.left {
  padding-left: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/xiayan/home/common/Header.vue